var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _g3, _g4, _g5, _path8, _path9, _path10, _path11, _path12, _path13, _g6, _path14, _circle, _path15, _path16, _path17, _g7, _g8, _path18, _ellipse, _path19, _rect, _rect2, _rect3, _rect4, _circle2, _circle3, _line, _circle4, _circle5, _circle6, _circle7, _circle8, _path20, _rect5, _rect6, _rect7, _circle9, _rect8, _path21, _path22, _ellipse2, _path23, _path24, _path25, _rect9, _path26, _path27, _path28, _path29, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageForbidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 295,
    viewBox: "0 0 294 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.083 1.07685L125.277 276.077C125.317 276.598 125.752 277 126.274 277H133.369C133.941 277 134.397 276.521 134.368 275.949L121.132 15.4138C121.103 14.8424 121.559 14.3631 122.131 14.3631H275.871C276.443 14.3631 276.898 14.8411 276.87 15.4118L264.163 275.951C264.136 276.522 264.591 277 265.162 277H272.258C272.781 277 273.216 276.597 273.255 276.075L293.919 1.07493C293.963 0.49476 293.504 0 292.922 0H105.08C104.497 0 104.038 0.496002 104.083 1.07685Z",
    fill: "#E4F1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139 277L126 21H271.5L259.5 277H139Z",
    fill: "#E9835B",
    stroke: "#E9835B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148 128L143 39H191.5L193.5 128H148Z",
    fill: "#E47349",
    stroke: "#F69A6B",
    strokeOpacity: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1500_16558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.5 122L152 47H187V122H156.5Z",
    fill: "#E9835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5 122L152 47H187V122H156.5Z",
    stroke: "#E9835B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 127.5V38.5H255.5L250.5 127.5H205.5Z",
    fill: "#E37248",
    stroke: "#F69A6B",
    strokeOpacity: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149 167.5V141.5L252 136.5V167.5H149Z",
    fill: "#E77249",
    stroke: "#F69A6B",
    strokeOpacity: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1500_16558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.5 162V148.5L243 145V162H158.5Z",
    fill: "#E9835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5 162V148.5L243 145V162H158.5Z",
    stroke: "#E6845A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150 257.5L146.5 176.5H195.5L192.5 257.5H150Z",
    fill: "#E77249",
    stroke: "#F69A6B",
    strokeOpacity: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 258V177.5H250.5L247 258H205.5Z",
    fill: "#E77249",
    stroke: "#F69A6B",
    strokeOpacity: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1500_16558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158 251L155 182.5H189.5V251H158Z",
    fill: "#E9835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 251L155 182.5H189.5V251H158Z",
    stroke: "#E9835B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1500_16558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.5 248V183.5H241.5V250L211.5 248Z",
    fill: "#E9835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.5 248V183.5H241.5V250L211.5 248Z",
    stroke: "#E9835B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1500_16558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.5 47H212.5L210 122.5H242.5L244.5 47Z",
    fill: "#E9835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.5 47H212.5L210 122.5H242.5L244.5 47Z",
    stroke: "#E9835B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 248V182.5H242",
    stroke: "#F5956B",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5 251L154.5 182H189.5",
    stroke: "#F5956B",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.5 162V148.5L243.5 145",
    stroke: "#F5956B",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.5 122.5L152 47H187",
    stroke: "#F5956B",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209.5 123L212.5 46.5H244.5",
    stroke: "#F5956B",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M168.5 82L166 67L233 69.1429L231 82H168.5Z",
    fill: "#FDB03C",
    stroke: "#F9994D",
    strokeLinejoin: "round"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1500_16558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139 169L136.5 138.5H145.5V169H139Z",
    fill: "#FDB03C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 169L136.5 138.5H145.5V169H139Z",
    stroke: "#FDB03C",
    strokeLinejoin: "round"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.356 162L140.85 158.543H142.167L142.826 162H140.356Z",
    fill: "#424242"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 141.485,
    cy: 157.485,
    r: 1.48485,
    fill: "#424242"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M191.48 75.23L193.92 71.97C194.027 71.9367 194.153 71.91 194.3 71.89C194.447 71.8633 194.577 71.85 194.69 71.85C194.863 71.85 195.03 71.8733 195.19 71.92C195.35 71.9667 195.48 72.05 195.58 72.17C195.68 72.29 195.73 72.46 195.73 72.68V75.54H196.57C196.603 75.6 196.637 75.6833 196.67 75.79C196.71 75.8967 196.73 76.01 196.73 76.13C196.73 76.3433 196.68 76.5 196.58 76.6C196.48 76.6933 196.353 76.74 196.2 76.74H195.73V78C195.67 78.0067 195.573 78.02 195.44 78.04C195.313 78.0667 195.193 78.08 195.08 78.08C194.827 78.08 194.63 78.0433 194.49 77.97C194.35 77.8967 194.28 77.7267 194.28 77.46V76.74H191.79C191.657 76.6733 191.54 76.57 191.44 76.43C191.347 76.29 191.3 76.12 191.3 75.92C191.3 75.8067 191.313 75.6867 191.34 75.56C191.367 75.4333 191.413 75.3233 191.48 75.23ZM194.35 75.54L194.36 73.35H194.33L192.85 75.54H194.35ZM201.096 74.96C201.096 74.52 201.05 74.1533 200.956 73.86C200.863 73.56 200.733 73.3367 200.566 73.19C200.4 73.0433 200.203 72.97 199.976 72.97C199.756 72.97 199.563 73.0467 199.396 73.2C199.23 73.3467 199.1 73.5667 199.006 73.86C198.92 74.1533 198.876 74.52 198.876 74.96C198.876 75.6267 198.973 76.1267 199.166 76.46C199.36 76.7933 199.63 76.96 199.976 76.96C200.336 76.96 200.613 76.7933 200.806 76.46C201 76.1267 201.096 75.6267 201.096 74.96ZM199.986 78.15C199.473 78.15 199.02 78.0333 198.626 77.8C198.24 77.56 197.936 77.2033 197.716 76.73C197.496 76.2567 197.386 75.6667 197.386 74.96C197.386 74.2533 197.5 73.6667 197.726 73.2C197.953 72.7267 198.26 72.3733 198.646 72.14C199.04 71.9 199.486 71.78 199.986 71.78C200.48 71.78 200.923 71.9 201.316 72.14C201.71 72.3733 202.02 72.7267 202.246 73.2C202.48 73.6733 202.596 74.26 202.596 74.96C202.596 75.6667 202.483 76.2567 202.256 76.73C202.036 77.2033 201.73 77.56 201.336 77.8C200.943 78.0333 200.493 78.15 199.986 78.15ZM205.194 71.77C205.928 71.77 206.494 71.9267 206.894 72.24C207.294 72.5467 207.494 72.9667 207.494 73.5C207.494 73.7267 207.451 73.93 207.364 74.11C207.278 74.2833 207.168 74.43 207.034 74.55C206.901 74.67 206.758 74.7633 206.604 74.83C206.791 74.89 206.961 74.9833 207.114 75.11C207.274 75.2367 207.401 75.4 207.494 75.6C207.594 75.7933 207.644 76.0333 207.644 76.32C207.644 76.7 207.541 77.03 207.334 77.31C207.128 77.5833 206.841 77.7933 206.474 77.94C206.114 78.08 205.694 78.15 205.214 78.15C204.781 78.15 204.411 78.1067 204.104 78.02C203.804 77.94 203.574 77.8267 203.414 77.68C203.254 77.5267 203.174 77.36 203.174 77.18C203.174 77.02 203.211 76.88 203.284 76.76C203.364 76.64 203.461 76.55 203.574 76.49C203.721 76.59 203.908 76.6933 204.134 76.8C204.368 76.9067 204.668 76.96 205.034 76.96C205.394 76.96 205.671 76.89 205.864 76.75C206.058 76.61 206.154 76.4233 206.154 76.19C206.154 75.9633 206.074 75.7867 205.914 75.66C205.754 75.5333 205.494 75.47 205.134 75.47H204.224C204.178 75.4033 204.138 75.3233 204.104 75.23C204.078 75.13 204.064 75.0167 204.064 74.89C204.064 74.7567 204.078 74.64 204.104 74.54C204.138 74.44 204.178 74.36 204.224 74.3H205.114C205.421 74.3 205.644 74.2433 205.784 74.13C205.924 74.0167 205.994 73.8533 205.994 73.64C205.994 73.4333 205.908 73.27 205.734 73.15C205.561 73.0233 205.308 72.96 204.974 72.96C204.694 72.96 204.444 72.9967 204.224 73.07C204.011 73.1433 203.834 73.23 203.694 73.33C203.594 73.2567 203.508 73.1667 203.434 73.06C203.368 72.9533 203.334 72.83 203.334 72.69C203.334 72.49 203.411 72.3233 203.564 72.19C203.718 72.0567 203.934 71.9533 204.214 71.88C204.501 71.8067 204.828 71.77 205.194 71.77Z",
    fill: "#E27248"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110 6L130 277.5H138.5L126 20.0779H272L260 277.5H268.5L288 6H110Z",
    fill: "#FCF7E3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5 160.001L141.5 145.001L152.5 161.5",
    stroke: "#424242"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1500_16558)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 141,
    cy: 146,
    rx: 3,
    ry: 5,
    fill: "url(#paint0_linear_1500_16558)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1500_16558)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.137,
    y: 157.965,
    width: 37,
    height: 18,
    rx: 2,
    transform: "rotate(6.4941 122.137 157.965)",
    fill: "url(#paint1_linear_1500_16558)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.098 166.891C130.084 167.013 130.04 167.115 129.966 167.198C129.892 167.281 129.813 167.344 129.727 167.388C129.605 167.283 129.463 167.186 129.301 167.098C129.145 167.011 128.952 166.954 128.725 166.928C128.444 166.896 128.193 166.929 127.973 167.027C127.752 167.126 127.573 167.285 127.435 167.506C127.302 167.727 127.217 168.004 127.179 168.338C127.121 168.847 127.204 169.248 127.429 169.542C127.653 169.836 127.987 170.008 128.433 170.059C128.66 170.085 128.86 170.075 129.032 170.031C129.203 169.986 129.362 169.931 129.509 169.868C129.582 169.935 129.637 170.019 129.674 170.12C129.716 170.216 129.731 170.325 129.717 170.447C129.705 170.553 129.665 170.647 129.596 170.731C129.533 170.815 129.431 170.881 129.292 170.93C129.185 170.971 129.036 171.005 128.845 171.032C128.654 171.058 128.426 171.057 128.161 171.027C127.695 170.973 127.279 170.835 126.912 170.611C126.552 170.382 126.282 170.069 126.101 169.673C125.922 169.271 125.865 168.779 125.931 168.196C125.994 167.645 126.155 167.194 126.415 166.842C126.681 166.486 127.011 166.231 127.404 166.077C127.798 165.923 128.219 165.872 128.67 165.923C128.983 165.959 129.249 166.027 129.468 166.127C129.688 166.222 129.852 166.337 129.96 166.473C130.069 166.603 130.114 166.743 130.098 166.891ZM130.856 167.807L132.065 167.944L131.689 171.243L131.118 171.242C130.922 171.22 130.772 171.144 130.669 171.014C130.565 170.884 130.525 170.721 130.547 170.525L130.856 167.807ZM131.118 171.242L131.23 170.257L133.726 170.541C133.757 170.598 133.781 170.67 133.798 170.758C133.815 170.841 133.818 170.932 133.806 171.033C133.787 171.203 133.736 171.326 133.652 171.402C133.568 171.478 133.46 171.509 133.327 171.494L131.118 171.242ZM131.893 169.454L130.685 169.317L131.026 166.32C131.08 166.316 131.161 166.311 131.269 166.308C131.382 166.304 131.489 166.309 131.589 166.32C131.822 166.347 131.985 166.405 132.077 166.496C132.168 166.587 132.201 166.744 132.176 166.967L131.893 169.454ZM139.244 169.703C139.181 170.255 139.019 170.708 138.759 171.065C138.504 171.417 138.177 171.67 137.779 171.823C137.385 171.977 136.953 172.027 136.481 171.974C136.01 171.92 135.599 171.774 135.251 171.536C134.902 171.297 134.643 170.978 134.474 170.578C134.306 170.172 134.253 169.694 134.316 169.142C134.378 168.591 134.54 168.14 134.8 167.789C135.06 167.432 135.387 167.179 135.78 167.031C136.173 166.877 136.6 166.826 137.061 166.878C137.528 166.932 137.935 167.077 138.284 167.316C138.638 167.549 138.902 167.869 139.076 168.275C139.251 168.676 139.306 169.152 139.244 169.703ZM137.996 169.561C138.054 169.053 137.986 168.653 137.794 168.363C137.607 168.073 137.325 167.907 136.949 167.864C136.589 167.823 136.282 167.922 136.029 168.162C135.777 168.396 135.622 168.77 135.563 169.285C135.504 169.804 135.568 170.208 135.755 170.498C135.948 170.783 136.23 170.947 136.601 170.989C136.972 171.031 137.281 170.935 137.528 170.7C137.781 170.46 137.937 170.081 137.996 169.561ZM141.388 171.534C141.674 171.566 141.884 171.539 142.017 171.452C142.156 171.361 142.234 171.244 142.251 171.1C142.266 170.968 142.227 170.856 142.136 170.765C142.05 170.67 141.915 170.582 141.731 170.502L141.325 170.319C141.05 170.191 140.807 170.056 140.598 169.914C140.394 169.773 140.242 169.602 140.141 169.403C140.046 169.204 140.014 168.962 140.047 168.676C140.097 168.236 140.303 167.905 140.667 167.683C141.03 167.462 141.509 167.385 142.102 167.452C142.404 167.487 142.669 167.546 142.895 167.631C143.127 167.717 143.302 167.825 143.422 167.957C143.547 168.084 143.6 168.229 143.581 168.394C143.567 168.515 143.526 168.618 143.458 168.702C143.395 168.78 143.318 168.847 143.226 168.901C143.113 168.802 142.96 168.712 142.765 168.631C142.571 168.544 142.352 168.487 142.108 168.459C141.854 168.43 141.658 168.451 141.522 168.521C141.385 168.586 141.31 168.685 141.295 168.818C141.283 168.924 141.315 169.016 141.392 169.094C141.469 169.168 141.59 169.24 141.754 169.313L142.175 169.498C142.641 169.701 142.989 169.942 143.22 170.221C143.452 170.494 143.545 170.837 143.498 171.25C143.447 171.696 143.233 172.039 142.857 172.281C142.481 172.517 141.967 172.598 141.316 172.524C140.992 172.487 140.707 172.42 140.461 172.322C140.214 172.224 140.022 172.1 139.883 171.95C139.75 171.801 139.693 171.639 139.713 171.464C139.729 171.326 139.782 171.214 139.872 171.128C139.968 171.037 140.07 170.973 140.176 170.937C140.306 171.07 140.471 171.196 140.672 171.315C140.879 171.43 141.118 171.503 141.388 171.534ZM144.56 169.342L145.736 169.476L145.358 172.799C145.309 172.804 145.233 172.809 145.131 172.813C145.034 172.818 144.929 172.814 144.818 172.802C144.622 172.779 144.472 172.703 144.369 172.574C144.266 172.444 144.225 172.281 144.248 172.085L144.56 169.342ZM145.517 171.4L144.341 171.266L144.651 168.54C144.674 168.338 144.75 168.188 144.879 168.09C145.009 167.987 145.172 167.947 145.368 167.969C145.48 167.982 145.582 168.001 145.676 168.028C145.774 168.055 145.847 168.077 145.894 168.093L145.517 171.4ZM145.045 170.807L145.154 169.853L147.554 170.126C147.58 170.183 147.602 170.252 147.619 170.335C147.637 170.417 147.64 170.506 147.629 170.602C147.61 170.771 147.556 170.891 147.467 170.962C147.384 171.033 147.279 171.061 147.152 171.046L145.045 170.807ZM144.818 172.802L144.928 171.84L147.59 172.143C147.617 172.194 147.638 172.264 147.655 172.352C147.672 172.44 147.675 172.531 147.664 172.627C147.645 172.796 147.591 172.916 147.502 172.987C147.419 173.058 147.314 173.086 147.187 173.071L144.818 172.802ZM145.26 168.923L145.368 167.969L147.991 168.268C148.023 168.319 148.045 168.386 148.057 168.468C148.075 168.551 148.078 168.64 148.067 168.735C148.048 168.905 147.996 169.028 147.912 169.104C147.829 169.175 147.721 169.203 147.589 169.188L145.26 168.923ZM151.914 171.154C151.856 171.662 151.685 172.032 151.401 172.263C151.122 172.494 150.774 172.586 150.355 172.538C150.265 172.528 150.17 172.515 150.07 172.498C149.97 172.476 149.882 172.452 149.804 172.427L150.147 169.415C150.238 169.414 150.327 169.416 150.412 169.421C150.503 169.42 150.597 169.426 150.692 169.437C150.968 169.468 151.202 169.554 151.395 169.694C151.595 169.829 151.74 170.017 151.83 170.259C151.926 170.5 151.954 170.799 151.914 171.154ZM153.164 171.272C153.229 170.705 153.168 170.223 152.983 169.826C152.797 169.429 152.51 169.117 152.123 168.891C151.741 168.66 151.278 168.513 150.732 168.451C150.53 168.428 150.307 168.413 150.06 168.406C149.814 168.4 149.581 168.419 149.362 168.464C149.262 168.49 149.18 168.529 149.115 168.581C149.05 168.627 149.012 168.703 149 168.809L148.568 172.609C148.539 172.863 148.656 173.056 148.92 173.188C149.119 173.286 149.344 173.36 149.596 173.41C149.847 173.465 150.06 173.503 150.235 173.523C150.765 173.583 151.236 173.543 151.65 173.402C152.069 173.257 152.408 173.008 152.669 172.657C152.934 172.306 153.099 171.844 153.164 171.272Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5,
    cy: 291,
    rx: 28.5,
    ry: 4,
    fill: "#D2E7FE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04898 211.553C0.901439 203.637 6.16592 196.214 14.0152 194.679L63.6219 184.979C71.9502 183.351 79.97 188.949 81.3118 197.328L89.6586 249.451C90.9566 257.557 85.4982 265.2 77.4101 266.602L26.8775 275.365C18.5545 276.808 10.6818 271.098 9.46984 262.738L2.04898 211.553Z",
    fill: "#3C89F7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 262,
    width: 13,
    height: 29,
    rx: 6,
    fill: "#3C89F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 262,
    width: 13,
    height: 29,
    rx: 6,
    fill: "#3C89F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 279,
    width: 13,
    height: 5,
    fill: "#FF6600"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 279,
    width: 13,
    height: 5,
    fill: "#FF6600"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 233,
    r: 7.5,
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 228,
    r: 7.5,
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64.9178,
    y1: 226.507,
    x2: 70.9178,
    y2: 225.507,
    stroke: "#FBFBFB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 235,
    r: 2,
    fill: "#05157B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 229,
    r: 2,
    fill: "#05157B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 244.5,
    r: 2.5,
    fill: "#5AB3E2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 239.5,
    r: 2.5,
    fill: "#5AB3E2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 248,
    r: 6,
    fill: "#05157B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5 250.011C81.5 251.944 78.433 254 76.5 254C75 253.989 72 253.5 72 252C72 250.067 74.567 249.512 76.5 249.512C78.433 249.512 81.5 248.078 81.5 250.011Z",
    fill: "#EB4E86"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 248.113,
    width: 5.85741,
    height: 2.7315,
    rx: 1,
    transform: "rotate(-1.1099 104 248.113)",
    fill: "#3C89F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 105.317,
    y: 251.078,
    width: 4.86723,
    height: 2.7315,
    rx: 1,
    transform: "rotate(19.3839 105.317 251.078)",
    fill: "#3C89F7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 105.056,
    y: 253.492,
    width: 4.43439,
    height: 2.7315,
    rx: 1,
    transform: "rotate(37.5685 105.056 253.492)",
    fill: "#3C89F7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 253.5,
    r: 4.5,
    fill: "#3C89F7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 243.435,
    width: 1.5,
    height: 2,
    transform: "rotate(-16.7706 102 243.435)",
    fill: "#8B4AD1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.512 230.106C107.134 233.637 106.938 236.943 106.142 239.426C105.338 241.933 103.975 243.468 102.355 243.753C100.736 244.038 98.9302 243.062 97.3177 240.98C95.7211 238.918 94.4074 235.879 93.7854 232.347C93.1634 228.816 93.3595 225.51 94.1557 223.027C94.96 220.52 96.323 218.985 97.9425 218.7C99.5621 218.415 101.367 219.391 102.98 221.473C104.577 223.534 105.89 226.574 106.512 230.106Z",
    fill: "#3F61FD",
    stroke: "#6E8AFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.717 230.074C107.318 233.485 107.239 236.659 106.646 239.025C106.349 240.209 105.93 241.167 105.422 241.851C104.917 242.532 104.344 242.918 103.73 243.026C103.116 243.135 102.446 242.967 101.738 242.5C101.028 242.03 100.306 241.273 99.6226 240.262C98.2566 238.241 97.0983 235.285 96.4974 231.874C95.8965 228.462 95.9752 225.288 96.5685 222.922C96.8652 221.738 97.2849 220.78 97.7923 220.096C98.2975 219.415 98.8704 219.029 99.4845 218.921C100.099 218.813 100.769 218.98 101.476 219.447C102.187 219.917 102.909 220.674 103.592 221.685C104.958 223.706 106.116 226.662 106.717 230.074Z",
    fill: "#B3E1F7",
    stroke: "#6884FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.841,
    cy: 226.355,
    rx: 2.44507,
    ry: 3.27719,
    transform: "rotate(-9.98903 101.841 226.355)",
    fill: "#FBFBFB",
    fillOpacity: 0.37
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M104 245.001L102.5 245.501C102.5 245.501 103 252.501 104.119 255.001L106.5 254.501C106.034 251.386 104 245.001 104 245.001Z",
    fill: "#FCBF2D",
    stroke: "#FBBE2C",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 253.001L106 252.501",
    stroke: "#8B4AD1",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 248.001L105 247.501",
    stroke: "#8B4AD1",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 250.648,
    width: 7.30021,
    height: 2.7315,
    rx: 1,
    transform: "rotate(-30 98 250.648)",
    fill: "#3C89F7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 251.5C102.5 251.5 101.96 252.052 101.283 252.186C100.606 252.321 99.9997 251.43 99.9997 251.43",
    stroke: "#0060CC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M102 216C102 216 103.887 217.081 104.5 218C105.5 219.5 105.5 220 105.5 220",
    stroke: "#D2E7FE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M103 214C103 214 104.887 215.081 105.5 216C106.5 217.5 106.5 218 106.5 218",
    stroke: "#D2E7FE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M106.93 290.879L273 277H125.919C125.761 277 125.682 277 125.605 277.012C125.54 277.022 125.476 277.039 125.414 277.062C125.341 277.089 125.272 277.127 125.134 277.204L106.012 287.869C104.111 288.929 103.16 289.459 103.059 289.886C102.975 290.238 103.088 290.608 103.354 290.853C103.677 291.151 104.761 291.06 106.93 290.879H106.93Z",
    fill: "#D2E7FE",
    fillOpacity: 0.48
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1500_16558",
    x: 149.5,
    y: 44.5,
    width: 44,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1500_16558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1500_16558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1500_16558",
    x: 155,
    y: 141.5,
    width: 93.5,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1500_16558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1500_16558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1500_16558",
    x: 152.5,
    y: 180,
    width: 43.5,
    height: 77.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1500_16558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1500_16558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1500_16558",
    x: 209,
    y: 181,
    width: 39,
    height: 75.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1500_16558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1500_16558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1500_16558",
    x: 207.5,
    y: 44.5,
    width: 43.5,
    height: 84.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1500_16558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1500_16558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1500_16558",
    x: 134,
    y: 135,
    width: 18,
    height: 39.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1500_16558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1500_16558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1500_16558",
    x: 137,
    y: 141,
    width: 8,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1500_16558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1500_16558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1500_16558",
    x: 116.314,
    y: 158.178,
    width: 46.3721,
    height: 29.6428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.258824 0 0 0 0 0.258824 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1500_16558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1500_16558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1500_16558",
    x1: 141,
    y1: 141,
    x2: 141,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07817"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1500_16558",
    x1: 123.62,
    y1: 163.367,
    x2: 156.219,
    y2: 171.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2F4C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageForbidden);
export default __webpack_public_path__ + "static/media/page-forbidden.475e4c7253d52a8457354a3c1e9eb6d7.svg";
export { ForwardRef as ReactComponent };